export enum MutationTypes {
    SET_NEW_PARAMS = 'SET_NEW_PARAMS',
}
